import { render, staticRenderFns } from "./addIndustry.vue?vue&type=template&id=9cd550d0&"
import script from "./addIndustry.vue?vue&type=script&lang=js&"
export * from "./addIndustry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports